import { useSelector } from 'react-redux';
import mapStateToProps from './mapStateToProps';

import ExcelIcon from '../../assets/img/Excel'
import { periodTypes } from '../../const';

import { IconButton } from '@mui/material';
import { getCriteria } from '../../shared/helpers/getCriteria';


const DownloadExcelBtn = () => {
    const {
        selectedGeoObjArray,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        getMultiGeoObjReportExcel,
        geoMultiObjReportExcel,
    } = useSelector(mapStateToProps)

    const handleClick = () => {
        if (geoMultiObjReportExcel?.abort) geoMultiObjReportExcel.abort();
        const criteria = getCriteria(
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
        )
        getMultiGeoObjReportExcel({
            objIds:selectedGeoObjArray,
            criteria
        })
    }

    return <IconButton disabled={!selectedGeoObjArray?.length} color="mainButton" onClick={handleClick} ><ExcelIcon /></IconButton>
}
export default DownloadExcelBtn